<!-- Container-fluid starts-->
<div class="container-fluid">
    <div class="col-lg-12 col-md-12 col-12">
      <div class="card">
        <div class="card-body row">
          <div class="custom-datatable col-lg-6 col-md-6 col-12">
              <ngx-datatable
              class='bootstrap'
              [columnMode]="ColumnMode.force"
              [headerHeight]="50"
              [footerHeight]="50"
              [rowHeight]="'auto'"
              [selected]="selected"
              [selectionType]="SelectionType.single"
              [rows]="advertisersData"
              (select)="onSelect($event)"
              >
              <ngx-datatable-column name="name">
                <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                  <span class="myHeader txt-primary" (click)="sort()">Advertiser</span>
                </ng-template>
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row.name }}
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="email">
                <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                  <span class="myHeader txt-primary" (click)="sort()">E-mail</span>
                </ng-template>
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row.email }}
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="phone">
                <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                  <span class="myHeader txt-primary" (click)="sort()">Phone</span>
                </ng-template>
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row.phone }}
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="rating">
                <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                  <span class="myHeader txt-primary" (click)="sort()">Rating</span>
                </ng-template>
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row.rating }}
                </ng-template>
              </ngx-datatable-column>

            </ngx-datatable>
          </div>

          <div class="col-lg-6 col-md-6 col-12">
            <div class="row">
              <div class="form-group col-md-6">
                <label class="form-label">Advertiser</label>
                <input class="form-control" type="text" placeholder="advertiser company name" *ngFor="let sel of selected" [(ngModel)]="sel.name" disabled>
              </div>
              <div class="form-group col-md-6">
                <label class="form-label">Rating</label><br>
                <ngb-rating [(ngModel)]="currentAdvertiser.rating" class="my_rating"></ngb-rating>
              </div>
            </div>

            <div class="row">
              <div class="form-group col-md-6">
                <label class="form-label">email</label>
                <input class="form-control" type="text" placeholder="email" [(ngModel)]="currentAdvertiser.email">
              </div>
              <div class="form-group col-md-6">
                <label class="form-label">Phone</label>
                <input class="form-control" type="text" placeholder="phone" [(ngModel)]="currentAdvertiser.phone">
              </div>
            </div>

            <div class="row">
              <div class="form-group col-md-12">
                <label class="form-label">Note</label>
                <textarea class="form-control" rows="8" placeholder="Notes about advertiser" [(ngModel)]="currentAdvertiser.about"></textarea>
              </div>
            </div>
            <button class="btn btn-pill btn-sm btn-info" type="button" placement="top" ngbTooltip="save advertiser data" (click)="onUpdate()">
                Update</button>
          </div>
        </div>
      </div>
    </div>

    <adm-adver-stats></adm-adver-stats>
</div>
<!-- Container-fluid Ends-->
